import wx from 'weixin-js-sdk';
import { post } from './request';

const isWeChat = () => {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua && ua.match(/MicroMessenger/i)+'' === 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

const isPhone = () => {
  let userAgentInfo = navigator.userAgent,
      flag = false,
      Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPod"];

  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = true;
      break;
    } else {
      flag = false;
    }
  }

  return flag;
}

const deleteUrlKey = (name) => {
  if (!name) {
    return null;
  }
  let local = window.location;
  let baseUrl = local.origin + local.pathname + "?";
  let query = local.search.substr(1);
  let returnUrl = local.href;

  let obj = {}
  let arr = query.split("&");
  for (var i = 0; i < arr.length; i++) {
      arr[i] = arr[i].split("=");
      obj[arr[i][0]] = arr[i][1];
  }

  if(query.indexOf('invite')>-1) {
    delete obj['invite'];
  }

  if(query.indexOf('state')>-1) {
    delete obj['state'];
  }

  if (query.indexOf(name)>-1) {
    delete obj[name];
  }

  let url = baseUrl + JSON.stringify(obj).replace(/[\"\{\}]/g,"").replace(/\:/g,"=").replace(/\,/g,"&");
  returnUrl =  url;

  return returnUrl;
}

const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

const wxShare = (wxTitle, wxDes, wxUrl, wxImg, callbackFn) => {
  if (isWeChat()){
    post(
      '/api/website/signature/weixin/', 
      {
        url: window.location.href
      }, {
        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'}
      })
    .then(res => {
      weChatCallBack(res.data, wxTitle, wxDes, wxUrl, wxImg, callbackFn);
    })
  }
  const weChatCallBack = (data, wxTitle = '小饭桌创业课堂活动报名', wxDes = '小饭桌创业课堂正在招生，更多活动等你来报名报名！', wxUrl = deleteUrlKey('code') , wxImg = 'https://static-image.xfz.cn/xfz-share-logo-300.png') => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: data.app_id, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.noncestr, // 必填，生成签名的随机串
      signature: data.signature, // 必填，签名，见附录1
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage'
      ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });

    wx.ready(function () {
      wx.onMenuShareTimeline({
        title: wxTitle, // 分享标题
        link: wxUrl, // 分享链接
        imgUrl: wxImg, // 分享图标
        desc: wxDes,
        success: function () {
        },
        cancel: function () {
        }
      });
      wx.onMenuShareAppMessage({
        title: wxTitle, // 分享标题
        link: wxUrl, // 分享链接
        imgUrl: wxImg, // 分享图标
        desc: wxDes,
        type: '', // 分享类型,music、video或link，不填默认为link
        dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
        success: function () {
        },
        cancel: function () {
        }
      });
    });
  }
}

const regExpression = () => {
  /*eslint no-useless-escape: "off"*/
  return {
    phoneReg: /^1[0-9][0-9]{9}$/,
    emailReg: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
    financingRoundSmallest: ['种子轮','天使轮', 'Pre-A轮', 'A轮', 'A+轮', 'Pre-B轮', 'B轮', 'B+轮', 'C轮'],
    financingRoundSmall: ['尚未获投', '种子轮','天使轮', 'Pre-A轮', 'A轮', 'A+轮', 'Pre-B轮', 'B轮', 'B+轮', 'C轮'],
    financingRoundAll: ['尚未获投', '种子轮','天使轮', 'Pre-A轮', 'A轮', 'A+轮', 'Pre-B轮', 'B轮', 'B+轮', 'C轮', 'D轮', 'E轮', 'F轮-上市前', '新三板', '战略投资', '已被收购', '已上市'],
    financingRoundType4:['尚未获投','天使/种子轮','A轮','B轮','C轮','D轮及以后','已上市'],
  }
}


const constant = () => {
  return {
    companyStructure: ['人民币架构', '美元架构', '美元/人民币架构', 'VIE架构', 'JV架构'],
  }
} 

// 定位到锚点

const scrollToAnchor = (anchorName) => {
  if (anchorName) {
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if(anchorElement) { anchorElement.scrollIntoView({block: 'start', behavior: 'smooth'}); }
  }
}
export {
  isWeChat,
  isPhone,
  wxShare,
  regExpression,
  constant,
  deleteUrlKey,
  getParameterByName,
  scrollToAnchor
}